import { api } from "./http-client";
import { AuditLog } from "../interfaces/audit-log.interface";
import { PageDto } from "../types/pagination";
import {
  AuditLogFilterOptions,
  AuditLogPageOptionsDto,
} from "../dtos/audit-log.dto";

export const auditLogsService = {
  list: async (params?: AuditLogPageOptionsDto): Promise<PageDto<AuditLog>> => {
    const response = await api.request<PageDto<AuditLog>>({
      url: "/audit-logs",
      method: "GET",
      params,
    });
    return response.data;
  },

  filterOptions: async (): Promise<AuditLogFilterOptions> => {
    const response = await api.request<AuditLogFilterOptions>({
      url: "/audit-logs/filter-options",
      method: "GET",
    });
    return response.data;
  },
};
